import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactImageFallback from 'react-image-fallback';
import VideoThumbnail from 'react-video-thumbnail';
import {
  LOGO_LARGE_WHITE, FALLBACK_ICON, capitalizeEveryWord, OFFER_TYPE, MediaRender, MEDIA_VIEW_TYPE, renderDateRange,
} from '../../../utils';
import { MediaPopup } from '../../modals';

function BetaPostDetail(props) {
  const { betaPostDetail } = props;
  const {
    title, clientName, campaignType, viewType, offerMaxDate, offerMinDate, clientLogo, description,
  } = betaPostDetail.offerId;
  const [isOpenMediaPopup, setIsOpenMediaPopup] = useState(false);
  const [mediaItem, setMediaItem] = useState();

  /* function to close the publish post modal */
  const toggleMediaModal = () => {
    setIsOpenMediaPopup(!isOpenMediaPopup);
  };

  const openMediaPopup = (item) => {
    setIsOpenMediaPopup(true);
    setMediaItem(item);
  };

  const renderMedia = (mediaObj, mediaFile) => {
    switch (mediaFile.mediaType) {
      case MEDIA_VIEW_TYPE.IMAGE:
        return mediaObj;
      case MEDIA_VIEW_TYPE.VIDEO:
        return (
          <>
            <VideoThumbnail
              videoUrl={mediaFile.url}
            />
          </>
        );
      default:
        break;
    }
    return null;
  };

  return (
    <>
      <div className="offer-detail-wrapper beta-post-detail">
        <div className="beta-post-detail-head">
          <Link to="/login">
            <img
              src={LOGO_LARGE_WHITE}
              alt="logo"
            />
          </Link>
        </div>
        <div className="offer-detail-wrapper-content">
          <div className="offer-detail-wrapper-head">
            <div className="offer-detail-wrapper-head-image">
              <ReactImageFallback
                src={betaPostDetail && clientLogo}
                fallbackImage={FALLBACK_ICON}
                alt="Offer"
              />
            </div>
            <div className="offer-detail-wrapper-head-detail">
              <p>
                {betaPostDetail && clientName}
              </p>
              <h2>{betaPostDetail && title}</h2>
              <span>{betaPostDetail && OFFER_TYPE[campaignType]}</span>
              <span className="ml-1">{betaPostDetail && OFFER_TYPE[viewType]}</span>
              <em>
                {betaPostDetail && renderDateRange(offerMinDate, offerMaxDate)}
              </em>
            </div>
          </div>
          <p className="short-description">
            {betaPostDetail && description}
          </p>
          <h3>Draft Post</h3>
          <div className="offer-detail-wrapper-card">
            <div className="beta-post-user-head">
              <span>
                <ReactImageFallback
                  src={betaPostDetail && betaPostDetail.userId.artistImage}
                  fallbackImage={FALLBACK_ICON}
                  alt="user"
                />
              </span>
              <h3>{betaPostDetail && capitalizeEveryWord(betaPostDetail.userId.name)}</h3>
            </div>
            <div className="beta-post-media">
              {betaPostDetail && MediaRender(betaPostDetail.media).map((obj) => (
                <div
                  key={Math.random()}
                  className="beta-post-media-box"
                  onClick={() => openMediaPopup(obj && obj.file)}
                >
                  {renderMedia(obj.media, obj.file)}
                </div>
              ))}
            </div>
            <p>
              {betaPostDetail.betaPostInfo}
            </p>
          </div>
        </div>
      </div>
      {isOpenMediaPopup && (
        <MediaPopup
          isOpen={isOpenMediaPopup}
          onClose={() => { toggleMediaModal(); }}
          timelineData={mediaItem}
        />
      )}
    </>
  );
}

BetaPostDetail.propTypes = {
  betaPostDetail: PropTypes.shape({
    betaPostInfo: PropTypes.string,
    userId: PropTypes.shape({
      artistImage: PropTypes.string,
      name: PropTypes.string,
    }),
    media: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string,
      url: PropTypes.string,
      mediaType: PropTypes.string,
      thumbnail: PropTypes.string,
    })),
    offerId: PropTypes.shape({
      title: PropTypes.string,
      clientName: PropTypes.string,
      viewType: PropTypes.string,
      campaignType: PropTypes.string,
      description: PropTypes.string,
      clientLogo: PropTypes.string,
      offerMinDate: PropTypes.string,
      offerMaxDate: PropTypes.string,
    }),
  }),
};

BetaPostDetail.defaultProps = {
  betaPostDetail: {},
};

export default BetaPostDetail;
